import { Grid } from "react-loading-icons"
import styles from '../css/styles.module.css'

export const Loading = () => {
    return <div className={`d-flex align-items-center justify-content-center ${styles.loading_component}`}>
        <div className='d-flex align-items-center justify-content-center ' >
            <Grid />
        </div>
    </div>
}